import { FC, useEffect, useState } from 'react'
import Lottie from 'lottie-react'
import { useTranslations } from '../../../featureSliced/shared/hooks/useTranslations'
import { Button } from '../../../components/Button'
import { AnimationContainer, OrderModalContainer } from './styled'
import { AnimationData } from 'featureSliced/shared/utils/animations'
import { loadAnimation } from 'featureSliced/shared/utils/loadAnimation'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

type SuccessProps = {
  closeModal: () => void
}

export const Success: FC<SuccessProps> = ({ closeModal }) => {
  // Hooks
  const t = useTranslations()
  const appTheme = useMySelector((state) => state.app.interfaceStyles.appTheme)

  // State
  const [successAnimation, setSuccessAnimation] =
    useState<AnimationData | null>(null)

  // useEffects
  useEffect(() => {
    loadAnimation(`${appTheme}/orderSuccess.json`, (error) => {
      console.error('Failed to load success animation:', error)
    }).then(setSuccessAnimation)
  }, [])

  return (
    <OrderModalContainer>
      <h2>{t('order.thankYouMessage')}</h2>
      <AnimationContainer>
        <Lottie animationData={successAnimation} loop={true} />
      </AnimationContainer>
      <p>{t('order.thankYouSubMessage')}</p>
      <Button
        style={{ gridColumn: '1 / -1' }}
        width="100%"
        buttonType="common"
        onClick={closeModal}
      >
        {t('buttons.ok')}
      </Button>
    </OrderModalContainer>
  )
}
